import { RequestOptions } from '../Api';

export const LogLabels = {
  LoggerServiceAlreadyLoaded: 'Logger Service already loaded, using existing version',
  RequestStart: 'API Request Start',
  RequestUrlAlreadyRequested: (url: string): string => `%c ${url} is already requested`,
  RequestOptions: (_options: RequestOptions): string => `%c Request Options: ${JSON.stringify(_options, null, 2)}`,
  RequestComplete: 'API Request Complete.',
  RequestError: 'API Request error occurred',
  RequestInterceptorExecuted: 'API Request Request Interceptors executed',
  RequestIdempotencyAdded: 'API Request Idempotency key added.',
  ResponseConvertedToJSON: 'API Request Response converted to JSON.',
  ResponseInterceptorExecuted: 'API Request Response Interceptors executed',
  DefaultContentType: 'Defaul content type added',
  RequestUrlCached: 'Request url pushed to cacheInstance',
  RequestBodyParsed: 'Request body parsed',
  DefaultErrorHandler: 'Inside default error handlers',
  ReqeuestWithTraceId: 'Request with traceId',
  SplunkSuccessfulLog: (log: string): string => `%c Successfully Log sent to Splunk: ${log}`,
  SplunkFailedLog: (status: string): string => `Failed Log Request with Status code: ${status}`,
  SplunkErrorLog: (error: string): string => `Error while sending log to Splunk: ${error}`,
};
